import { render, staticRenderFns } from "./EditClientForm.vue?vue&type=template&id=0fbece80&scoped=true&"
import script from "./EditClientForm.vue?vue&type=script&lang=js&"
export * from "./EditClientForm.vue?vue&type=script&lang=js&"
import style0 from "./EditClientForm.vue?vue&type=style&index=0&id=0fbece80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbece80",
  null
  
)

export default component.exports